import script from "./NewRefundButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewRefundButton.vue?vue&type=script&lang=ts&setup=true"

import "./NewRefundButton.vue?vue&type=style&index=0&id=e051401e&scoped=true&lang=scss"

import exportComponent from "/home/deployer/pwa/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e051401e"]])

export default __exports__